var description_default = {
  "subtitle": "-BQZr",
  "descriptionItem": "iC8fY"
};
export {
  description_default as default
};
//# sourceMappingURL=description-scss.js.map
